import { Link } from "react-router";

export default function NotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-h1">404</h1>
      <p className="text-body text-grey-700">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <Link to="/screening-portal" className="rounded-2xl bg-green-700 px-4 py-2 text-white">
        Back to screening
      </Link>
    </div>
  );
}
